import { useFsFlag } from "@flagship.io/react-sdk";

function withFlagship(Component, abTestsName) {
	//TODO pour les abtests au prebook, reutiliser le flags prebook_flags
	function ComponentWithFlagship(props) {
		const abTests = useFsFlag(abTestsName, undefined);
		const abTestsValues = abTests.getValue();

		return <Component abTestsValues={abTestsValues} {...props} />;
	}

	return ComponentWithFlagship;
}

export default withFlagship;
